import React from "react";
import Hero from "../../components/Page8Components/Hero";
import InventoryTab from "../../components/Page8Components/InventoryTab";
const Page8 = () => {
  return (
    <div>
      <Hero></Hero>
      <InventoryTab></InventoryTab>
    </div>
  );
};

export default Page8;
